import React from "react";
import { UserPlus, ArrowRight } from "lucide-react";
import { Button } from "@shadcn-in-nx/ui/button";
import { useTranslation } from "react-i18next";

function PublishUsersTab({ onGoToUsers }) {
    const { t } = useTranslation();

    return (
        <div className="py-4 space-y-4 text-center">
            <div className="mx-auto w-10 h-10 rounded-full bg-blue-50 dark:bg-blue-950/30 flex items-center justify-center">
                <UserPlus className="w-5 h-5 text-blue-600 dark:text-blue-400" />
            </div>
            <div>
                <p className="font-medium text-sm">{t("publishModal.users.title")}</p>
                <p className="text-xs text-muted-foreground mt-1.5 max-w-[280px] mx-auto leading-relaxed">
                    {t("publishModal.users.descriptionHasMembers")}
                </p>
            </div>
            <Button size="sm" variant="outline" onClick={onGoToUsers} className="gap-1.5">
                {t("publishModal.users.manageUsers")}
                <ArrowRight className="w-3.5 h-3.5" />
            </Button>
        </div>
    );
}

export default React.memo(PublishUsersTab);
